import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=28719a01&scoped=true&"
import script from "./PostItem.vue.ts?vue&type=script&lang=ts&"
export * from "./PostItem.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28719a01",
  null
  
)

export default component.exports